module.exports = __webpack_public_path__ + "img/3.fbdb2fa7.png";